import { authService } from "@/common/api/services/auth";

export const isAuthenticated = async (): Promise<boolean> => {
  try {
    const token = localStorage.getItem("accessToken");
    if (!token) return false;

    const userData = await authService.validateToken(token);
    return !!userData;
  } catch (error) {
    localStorage.removeItem("accessToken");
    return false;
  }
};

export const PUBLIC_ROUTES = [
  "/auth/login",
  "/auth/register",
  "/auth/forgot-password",
  "/auth/reset-password",
];

export const isPublicRoute = (path: string): boolean => {
  return PUBLIC_ROUTES.some((route) => path.startsWith(route));
};

export const DEFAULT_PRIVATE_ROUTE = "/dashboard";
export const DEFAULT_PUBLIC_ROUTE = "/auth/login"; 